import ACTION_TYPES from "../types";

const INITIAL_STATE = {
    templates: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ACTION_TYPES.CREATE_TEMPLATE:
            return {
                ...state,
                templates: [...state.templates, action.payload],
            };
        case ACTION_TYPES.DELETE_TEMPLATE:
            return {
                ...state,
                templates: state.templates.filter(template => template.template_id !== action.payload),
            };
        case ACTION_TYPES.SET_TEMPLATE_DATA:
            return {
                ...state,
                templates: action.payload,  
            };
        default:
            return state;
    }
};
